import { fetchJson } from 'utils/fetch';
import { createAction } from 'redux-actions';
import { fetchSites } from './sites';

export const requestCustomersAction = createAction('case.FETCH_CUSTOMERS');
export const receiveCustomersAction = createAction(
  'case.FETCH_CUSTOMERS_SUCCESS'
);
export const selectCustomerAction = createAction('case.SELECT_CUSTOMER');

export const fetchCustomers = () => (dispatch, getState) => {
  const state = getState();
  if (state.customers.isFetching) {
    return Promise.resolve();
  }

  dispatch(requestCustomersAction());

  return fetchJson('/pco-manager/customers.json').then(response => {
    dispatch(receiveCustomersAction(response));
  });
};

export const selectCustomer = customerId => dispatch => {
  dispatch(selectCustomerAction(customerId));
  dispatch(fetchSites(customerId));
};



// WEBPACK FOOTER //
// ./src/modules/saas/aast/common/modals/case-transfer/actions/customers.js